
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UpdatesService } from '@shared/services/updates.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-update-banner',
    templateUrl: './update-banner.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class UpdateBannerComponent implements OnInit, OnDestroy {
  public isUpdateAvailable: boolean = Boolean(false);

  private updateSubscription: Subscription;

  constructor(private readonly _updates: UpdatesService) {}

  ngOnInit(): void {
    this.updateSubscription = this._updates.updatesCalled$.subscribe(
      (res: boolean) => {
        this.isUpdateAvailable = res;
      }
    );
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }

  public refresh(): void {
    this._updates.applyUpdate();
  }
}
